module.exports = __webpack_public_path__ + "img/IncreaseYourProductivity2.789663fe.png";